// src/Publications.jsx

const journalArticles = [
  {
    title:
      'Hackathons educacionais como processo para concepção de projetos integradores no Ensino Médio Profissionalizante',
    authors: 'CARVALHO, Karen Andressa de; GASPARINI, I.',
    venue: 'Boletim Online de Educação Matemática',
    year: '2023',
    img: '/images/boem.png', // coloque sua imagem
    link: 'https://revistas.udesc.br/index.php/boem/article/view/24867',
  },
  {
    title: 'Reaproveitamento de lixo eletrônico em benefício da educação',
    authors: 'CARVALHO, K. A.',
    venue: 'Revista Innovatio de Tecnologia e Ciências da Terra',
    year: '2017',
    img: '/images/innovatio-17.png',
    link: 'https://book.ugv.edu.br/index.php/innovatio/issue/view/9/9',
  },
  {
    title: 'Uso de software livre na educação pública brasileira',
    authors: 'CARVALHO, Karen Andressa de; OKOPINIK, D. L.',
    venue: 'Revista de Iniciação Científica',
    year: '2011',
    img: '#',
    link: '#',
  },
];

const conferencePapers = [
  {
    title:
      'A realização de um hackathon com estudantes do Ensino Médio apoiada pela abordagem de Design Thinking',
    authors: 'CARVALHO, Karen Andressa de; GASPARINI, I.',
    event: 'XXIX Workshop de Informática na Escola – WIE 2023',
    year: '2023',
    img: '/images/cbie-23.jfif',
    link: 'https://sol.sbc.org.br/index.php/wie/article/view/26348',
  },
  {
    title: 'As novas tecnologias frente à educação',
    authors: 'CARVALHO, K. A.',
    event: 'I Encontro de Tecnologia da Informação – ENTEC',
    year: '2016',
    img: '#',
    link: '#',
  },
  {
    title:
      'TI Verde: reaproveitamento de lixo eletrônico em benefício da educação',
    authors: 'CARVALHO, K. A.',
    event: 'I Encontro de Tecnologia da Informação – ENTEC',
    year: '2016',
   img: '#',
    link: '#',
  },
];

// Sequência didática maker (Lattes: sequência didática 2023) :contentReference[oaicite:0]{index=0}
const didacticSequences = [
  {
    title:
      'DA TEORIA À PRÁTICA: EXPLORANDO DADOS COM TRANSFORMAÇÃO DIGITAL E LÓGICA DE PROGRAMAÇÃO NA TRILHA EPT EM CIÊNCIA DE DADOS',
    type: 'Sequência didática maker',
    year: '2023',
    context:
      'Governo de Santa Catarina, Secretaria de Estado de Educação.',
    img: '/images/inovasc-8.png',
    link: 'https://drive.google.com/file/d/1VamTEJDIG8J4_ckpDwgjXc9ZsWM0qCSQ/view', // ajuste depois
  },
];

// Dissertação e produto educacional (mestrado profissional) :contentReference[oaicite:1]{index=1}
const dissertationProducts = [
  {
    title:
      'Um processo de hackathon educacional como estratégia para concepção de projetos integradores no Ensino Médio Profissionalizante',
    type:
      'Dissertação de mestrado profissional em Ensino de Ciências, Matemática e Tecnologias (UDESC)',
    year: '2023',
    link: 'https://sucupira-legado.capes.gov.br/sucupira/public/consultas/coleta/trabalhoConclusao/viewTrabalhoConclusao.jsf?popup=true&id_trabalho=14156519', // repositório/PPG quando tiver
  },
  {
    title: 'Produto educacional da dissertação',
    type:
      'Material didático/guia prático para aplicação de hackathons educacionais e projetos integradores no Ensino Médio Profissionalizante',
    year: '2023',
    link: 'https://educapes.capes.gov.br/handle/capes/742217',
  },
];

// Entrevistas e mídia (Lattes – programas de rádio/TV) :contentReference[oaicite:2]{index=2} :contentReference[oaicite:3]{index=3}
const interviews = [
  {
    title:
      'Compartilhar práticas é uma maneira de fortalecer comunidades de educadores',
    year: '2022',
    medium: 'Entrevista',
    img: '/images/porvir.png',
    link: 'https://porvir.org/compartilhar-praticas-e-uma-maneira-de-fortalecer-comunidades-de-educadores/',
  },
  {
    title: 'Por mais segurança na internet',
    year: '2021',
    medium: 'Entrevista',
    img: '/images/ocpnews.png',
    link: 'https://ocp.news/colunistas/por-mais-seguranca-na-internet',
  },
  {
    title: 'Da TI para Sala de Aula',
    year: '2020',
    medium: 'Entrevista',
    img: '/images/jdv.png',
    link: 'https://www.jdv.com.br/da-ti-para-sala-de-aula/',
  },
  {
    title:
      'Projeto jaraguaense é selecionado para participar de evento da Microsoft',
    year: '2020',
    medium: 'Programa de rádio ou TV – Entrevista',
    img: '/images/jdv.png',
    link: 'https://www.jdv.com.br/projeto-jaraguaense-e-selecionado-para-participar-de-evento-da-microsoft/',
  },
  {
    title:
      'Tecnologia nas escolas: comunicação e colaboração além da sala de aula',
    year: '2019',
    medium: 'Programa de rádio ou TV – Entrevista',
    img: '/images/logo-direcional-escolas.png',
    link: 'https://direcionalescolas.com.br/tecnologia-nas-escolas-comunicacao-e-colaboracao-alem-da-sala-de-aula/',
  },
  {
    title:
      'Gincana une pais, alunos e professores em escola de Jaraguá do Sul',
    year: '2016',
    medium: 'Entrevista',
    img: '/images/sedsc.png',
    link: 'https://estado.sc.gov.br/noticias/gincana-une-pais-alunos-e-professores-em-escola-de-jaragua-do-sul/',
  },
   {
    title:
      'Feira Estadual de Ciências termina com premiação e mais de 6 mil visitantes',
    year: '2015',
    medium: 'Entrevista',
    img: '/images/sedsc.png',
    link: 'https://estado.sc.gov.br/noticias/feira-estadual-de-ciencias-encerra-com-premiacao-e-mais-de-6-mil-visitantes/',
  },
   
];

// Perfis acadêmicos
const otherProfiles = [
  {
    label: 'Currículo Lattes',
    link: 'http://lattes.cnpq.br/8333168955510881',
  },
  {
    label: 'ORCID',
    link: 'https://orcid.org/0009-0008-3766-3146',
  },
];

function Publications() {
  return (
    <section id="publicacoes" className="section publications">
      <h2>Minhas publicações</h2>

      {/* Artigos em periódicos */}
      <div className="pub-section">
        <h3>Artigos em periódicos</h3>
        <p>
          Seleção dos principais artigos publicados em revistas científicas nas áreas de
          educação, tecnologias educacionais e informática na educação.
        </p>

        <div className="pub-grid">
          {journalArticles.map((art, index) => (
            <div className="pub-card" key={index}>
           
              <h4 className="pub-title">
                <a href={art.link} target="_blank" rel="noreferrer">
                  {art.title}
                </a>
              </h4>
              <p className="pub-meta">{art.authors}</p>
              <p className="pub-desc">
                {art.venue}, {art.year}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Trabalhos em eventos científicos */}
      <div className="pub-section">
        <h3>Trabalhos em eventos científicos</h3>
        <p>
          Trabalhos completos apresentados em congressos, workshops e encontros na área
          de Informática na Educação e Tecnologias Educacionais.
        </p>

        <div className="pub-grid">
          {conferencePapers.map((work, index) => (
            <div className="pub-card" key={index}>
            
              <h4 className="pub-title">
                <a href={work.link} target="_blank" rel="noreferrer">
                  {work.title}
                </a>
              </h4>
              <p className="pub-meta">{work.authors}</p>
              <p className="pub-desc">
                {work.event}, {work.year}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Sequência didática maker */}
      <div className="pub-section">
        <h3>Sequência didática maker</h3>
        <p>
          Material didático voltado à exploração de dados, transformação digital e lógica
          de programação na trilha EPT em Ciência de Dados.
        </p>

        <div className="pub-grid">
          {didacticSequences.map((item, index) => (
            <div className="pub-card" key={index}>
             
              <h4 className="pub-title">
                <a href={item.link} target="_blank" rel="noreferrer">
                  {item.title}
                </a>
              </h4>
              <p className="pub-meta">{item.type}</p>
              <p className="pub-desc">
                {item.context} – {item.year}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Dissertação e produto educacional */}
      <div className="pub-section">
        <h3>Dissertação e produto educacional</h3>
        <p>
          Resultado do mestrado profissional em Ensino de Ciências, Matemática e
          Tecnologias, articulando hackathons educacionais, projetos integradores e
          materiais de apoio para escolas.
        </p>

        <div className="pub-grid">
          {dissertationProducts.map((item, index) => (
            <div className="pub-card" key={index}>
              
              <h4 className="pub-title">
                <a href={item.link} target="_blank" rel="noreferrer">
                  {item.title}
                </a>
              </h4>
              <p className="pub-meta">{item.type}</p>
              <p className="pub-desc">{item.year}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Entrevistas na mídia */}
      <div className="pub-section">
        <h3>Entrevistas na mídia</h3>
        <p>
          Participações em programas de rádio e TV discutindo tecnologias educacionais,
          segurança na internet, projetos inovadores e experiências em escolas públicas.
        </p>

        <div className="pub-grid">
          {interviews.map((item, index) => (
            <div className="pub-card" key={index}>
              <img src={item.img} alt={item.title} className="pub-img" />
              <h4 className="pub-title">
                <a href={item.link} target="_blank" rel="noreferrer">
                  {item.title}
                </a>
              </h4>
              <p className="pub-meta">{item.medium}</p>
              <p className="pub-desc">{item.year}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Perfis acadêmicos */}
<div className="pub-section">
  <h3>Perfis acadêmicos</h3>
  <p>
    Acesse meus perfis completos com todas as publicações, produções,
    formações e contribuições acadêmicas.
  </p>

  <div className="profile-grid">
    {otherProfiles.map((item, index) => (
      <a
        key={index}
        href={item.link}
        target="_blank"
        rel="noreferrer"
        className="profile-card"
      >
        <div className="profile-icon">
          {item.label.includes("Lattes") && "📄"}
          {item.label.includes("ORCID") && "🟢"}
        </div>
        <div className="profile-info">
          <h4>{item.label}</h4>
          <p>Clique para acessar</p>
        </div>
      </a>
    ))}
  </div>
</div>

    </section>
  );
}

export default Publications;